import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { gettopOffer } from "../../store/slider/SliderAction";
import { Swiper, SwiperSlide } from "swiper/react";

const TopHeader = () => {
  // const dispatch = useDispatch();
  // const { t } = useTranslation();
  // const lan = useSelector((state) => state.LanSlicer.language);
  // const { topOffer, loading } = useSelector((state) => state.slider);

  // useEffect(() => {
  //   const promise = dispatch(gettopOffer(lan));
  //   return () => {
  //     promise.abort();
  //   };
  // }, [lan, dispatch]);
  return (
    <div className="top-bar hidden-sm hidden-xs">
        <div className="container">
          <div className="top-bar-line">
            <div className="row">
              <div className="top-bar-links">
                <ul className="col-sm-6 top-bar-acc">
                  <li className="top-bar-link"><Link to={"/login"}>My Account</Link></li>
                  <li className="top-bar-link"><Link to={"/contact"}>Contact</Link></li>
                </ul>
                <ul className="col-sm-6 text-right top-bar-currency-language">
                  <li>
                    Currency: <a href="#">USD<i className="fa fa-angle-down"></i></a>
                    <div className="currency-dropdown">
                      <ul>
                        <li><a href="#">USD</a></li>
                        <li><a href="#">EUR</a></li>
                      </ul>
                    </div>
                  </li>
                  <li className="language">
                    Language: <a href="#">ENG<i className="fa fa-angle-down"></i></a>
                    <div className="language-dropdown">
                      <ul>
                        <li><a href="#">English</a></li>
                        <li><a href="#">Spanish</a></li>
                        <li><a href="#">German</a></li>
                        <li><a href="#">Chinese</a></li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div className="social-icons">
                      <a href="#"><i className="fa fa-twitter"></i></a>
                      <a href="#"><i className="fa fa-facebook"></i></a>
                      <a href="#"><i className="fa fa-google-plus"></i></a>
                      <a href="#"><i className="fa fa-linkedin"></i></a>
                      <a href="#"><i className="fa fa-vimeo"></i></a>
                    </div>
                  </li>
                </ul>              
              </div>
            </div>
          </div>
          
        </div>
      </div>
  );
};

export default TopHeader;
